import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "题材分类", href: "#category" },
  { label: "热门推荐", href: "#recommend" },
  { label: "专题攻略", href: "#feature" },
  { label: "追番时间", href: "#timeline" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-[1400px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 ${
              scrolled ? "" : "text-white"
            }`}
          >
            <i className="ri-heart-3-fill text-lg"></i>
          </span>
          <span
            className={`font-display text-xl md:text-2xl tracking-wide ${
              scrolled ? "text-foreground-950" : "text-white"
            }`}
          >
            女神动漫
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap text-sm font-medium transition-colors hover:text-primary-600 ${
                scrolled ? "text-foreground-700" : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href="#recommend"
          className="hidden whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-primary-600 md:inline-flex"
        >
          开始选番
        </a>

        <button
          onClick={() => setOpen(!open)}
          className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
            scrolled ? "text-foreground-950" : "text-white"
          }`}
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}